import * as pdfjsLib from 'pdfjs-dist';
import { PDFError } from './types';
import { PDF_CONFIG } from './config';
import './initialize';

export async function loadPDFDocument(file: File) {
  try {
    // Load file as array buffer
    const arrayBuffer = await file.arrayBuffer();
    const data = new Uint8Array(arrayBuffer);

    // Create loading task with optimized settings
    const loadingTask = pdfjsLib.getDocument({
      data,
      cMapUrl: PDF_CONFIG.cMapUrl,
      cMapPacked: PDF_CONFIG.cMapPacked,
      standardFontDataUrl: PDF_CONFIG.standardFontDataUrl,
      useSystemFonts: true,
      useWorkerFetch: true,
      verbosity: 0
    });

    // Load document
    return await loadingTask.promise;
  } catch (error) {
    console.error('PDF loading error:', error);
    throw new PDFError(
      'Failed to load PDF document',
      'LOAD_ERROR',
      error
    );
  }
}